
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","width":"12","height":"2","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":".5","y":"5","width":"12","height":"2","rx":"1","fill":"currentColor"}}),_c('rect',{attrs:{"x":".5","y":"10","width":"12","height":"2","rx":"1","fill":"currentColor"}})])
          )
        }
      }
    